import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ICreateEntradaGate,
  IEditEntradaGate,
  IGetReceiptGateEntradaByIdParams
} from './entradaGate.model';

@Injectable({
  providedIn: 'root'
})
export class EntradaGateService {
  constructor(private http: HttpClient) {}

  CreateEntradaGate(body: ICreateEntradaGate, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}GateEntrada/CreateGateEntrada`,
      body,
      { headers: headers }
    );
  }

  public UpdateEntradaGate(
    pkAgendamento: number,
    body: IEditEntradaGate
  ): Observable<any> {
    const url = `${environment.baseURL}GateEntrada/UpdateGateEntrada?id=${pkAgendamento}`;

    return this.http.put<any>(url, body);
  }

  public GetEntradaGateInfoById(id?: number): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    let url = `${environment.baseURL}GateEntrada/GetGateEntradaInfoById`;

    if (!invalid.includes(id)) {
      url += `?id=${id}`;
    }

    return this.http.get<any>(url);
  }

  public GetEntradasGate({
    codigoGateEntrada,
    idEmpresa,
    nomeMotorista,
    placaCavalo,
    dataEntrada,
    pageNumber,
    pageSize,
    paginar = true
  }: {
    codigoGateEntrada?: string;
    idEmpresa?: string;
    nomeMotorista?: string;
    placaCavalo?: string;
    dataEntrada?: string;
    pageNumber?: number;
    pageSize?: number;
    paginar?: boolean;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN];

    const url = `${environment.baseURL}GateEntrada/GetGateEntradasInfo`;
    const params: any = {};

    if (codigoGateEntrada !== undefined && codigoGateEntrada !== null) {
      params.PK_GATE_ENTR = codigoGateEntrada;
    }
    if (idEmpresa !== undefined && idEmpresa !== null) {
      params.PK_EPSA = idEmpresa;
    }
    if (nomeMotorista !== undefined && nomeMotorista !== null) {
      params.NM_MTRT = nomeMotorista;
    }
    const placa = placaCavalo !== undefined && placaCavalo !== null
      ? String(placaCavalo).replace(/-/g, '').trim()
      : '';
    if (placa) {
      params.TX_PLCA_CAVA = placa;
    }
    if (dataEntrada !== undefined && dataEntrada !== null) {
      params.DT_GATE_ENTR = dataEntrada;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }
    if (!paginar) {
      params.PAGE_SIZE = 2147483647;
    }

    return this.http.get<any>(url, { params });
  }

  public GetReceiptGateEntradaById(
    id: number,
    tipoDocumento: number
  ): Observable<any> {
    const url = `${environment.baseURL}GateEntrada/GetReceiptGateEntradaById`;
    const params: any = {
      PK_GATE_ENTR: 0,
      FL_TIPO_DOCU: 0
    };

    params.PK_GATE_ENTR = id;
    params.FL_TIPO_DOCU = tipoDocumento;

    return this.http.get<any>(url, { params });
  }
}
